import { parseBooleanQueryValue } from './parseBooleanQueryValue';

export const getStreamMuted = (search: string): boolean => {
  const searchParams = new URLSearchParams(search);
  const mutedFromQuery = parseBooleanQueryValue(searchParams.get('muted'));
  const soundFromQuery = parseBooleanQueryValue(searchParams.get('sound'));

  return mutedFromQuery ?? (soundFromQuery === undefined ? true : !soundFromQuery);
};
